<template>
<svgIconBase :svgImgPath="require(`./../../assets/weather_icons/${WeatherIconName}.svg`)" :Width="width" :Height="heigth"></svgIconBase>
</template>

<script>
import svgIconBase from './svgIconBase';
export default {
    props: ['WeatherIconName', 'width', 'heigth'],
    components: {
        svgIconBase
    }
}
</script>
